import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.scss'
import BackgroundContainer from "@/components/Background/BackgroundContainer.vue";
import PaymentResult from "@/components/Common/PaymentResult.vue";

import {defineComponent} from "vue";
import store from "@/store";

const __default__ = defineComponent({
    data(): {
        fontUrl: string
    } {
        return {
            fontUrl: `url('/font/Storopia.woff2') format("woff2"), url('/font/Storopia.ttf')  format('truetype'), url('/font/Storopia.woff') format('woff')`,
        }
    },

    methods: {
        updateSize(): void
        {
            store.state.pageSize.width = window.innerWidth
            store.state.pageSize.height = window.innerHeight
        },
    },

    mounted(): void
    {
        this.updateSize()

        window.addEventListener('resize', this.updateSize)

        document.addEventListener('mousemove', (event) => {
            store.state.cursor.x = event.clientX
            store.state.cursor.y = event.clientY
        })
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "5e053b38": (_ctx.fontUrl)
}))


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackgroundContainer),
    _createVNode(PaymentResult),
    _createVNode(_component_RouterView, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, {
          name: route.meta.transition || 'fade',
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1032, ["name"])
      ]),
      _: 1
    })
  ], 64))
}
}

})